import React from 'react';

import { Container, Row, Col, Nav, NavItem, NavLink } from 'reactstrap';

const year = new Date();

const Footer = () => (
  <footer style={{ background: '#333', color: 'white' }}>
    <Container fluid>
      <Row>
        <Col>
          <Nav>
            <NavItem>
              <NavLink className="px-3 pt-3 pb-0" href="/about">About</NavLink>
            </NavItem>
            <NavItem>
              <NavLink className="px-3 pt-3 pb-0" href="/videos">Videos</NavLink>
            </NavItem>
          </Nav>
          <p className="px-3" style={{ color: 'rgba(255, 255, 255, .65)' }}>
            ©
            {year.getFullYear()}
            {' '}
            |
            {' '}
            <a style={{ color: 'rgba(255, 255, 255, .65)' }} className="" href="mailto:joe@joebandelli.com">
              joe@joebandelli.com
            </a>
          </p>
        </Col>
        <Col className="py-3 text-right">
          <a
            href="https://www.facebook.com/joebandelli"
            className=""
            target="_blank"
          >
            <i className="fa fa-2x px-1 fa-facebook-official" />
          </a>
          <a
            href="https://twitter.com/TheChosenJoey"
            className=""
            target="_blank"
          >
            <i className="fa fa-2x px-1 fa-twitter-square" />
          </a>
          <a
            href="http://www.instagram.com/TheChosenJoey"
            className=""
            target="_blank"
          >
            <i className="fa fa-2x px-1 fa-instagram" />
          </a>
          <a
            href="http://www.imdb.com/name/nm3494613/"
            className=""
            target="_blank"
          >
            <i className="fa fa-2x px-1 fa-imdb" />
          </a>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js